import HomePage from '../../pages/home'

export default {
  component: HomePage,
}



// WEBPACK FOOTER //
// ./src/routes/Home/index.js